<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@if (authorized$ | async) {
  <button mat-stroked-button [color]="color" (click)="edit()">{{ label }}</button>
}
